module.exports = __webpack_public_path__ + "img/Silver.99bbef0b.png";